import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import { ITransactionService } from "@shared/interfaces/transaction.interface";
import { TransactionPlatform } from "@shared/types/transactions/enum/transaction-platform.enum";
import { TransactionStatus } from "@shared/types/transactions/enum/transaction-status.enum";
import { TransactionListPaginatedDto } from "@shared/types/transactions/transaction-list-paginated.dto";

@appInjectable()
export class TransactionService
  extends BaseService
  implements ITransactionService
{
  private configService = appInject<IConfigService>(DI_TOKENS.configService);
  private httpClient = appInject<IHttpClientService>(
    DI_TOKENS.httpClientService,
  );
  private baseURL: string;

  constructor() {
    super();
    this.baseURL = this.configService.baseUrl;
  }

  async list(dto: {
    page?: number;
    pageSize?: number;
    disabled?: string;
    status?: TransactionStatus;
    platform?: TransactionPlatform;
  }): Promise<TransactionListPaginatedDto> {
    const { data } = await this.httpClient.get<TransactionListPaginatedDto>(
      "/transactions",
      {
        params: dto,
        baseURL: this.baseURL,
      },
    );

    return data;
  }
}
